import { Component, ElementRef, OnDestroy, ViewChild } from '@angular/core';
import { WalletWeb3Service } from '@services/web3modal.service';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject, takeUntil, timer } from 'rxjs';

@Component({
  selector: 'app-referal-modal',
  templateUrl: './referal-modal.component.html',
  styleUrl: './referal-modal.component.scss'
})
export class ReferalModalComponent implements OnDestroy {
  private destroyed$ = new Subject<void>();

  @ViewChild('promoCodeInput') promoCodeInput!: ElementRef;

  // keyRef = 'isShowRefferal';

  currentRefferal = '';
  showRef = false;

  onSuccess = () => {};

  constructor(
    public bsModalRef: BsModalRef,
    public walletService: WalletWeb3Service,
  ) {
    const ref = localStorage.getItem('ref') ?? '';

    if (ref) {
      this.currentRefferal = ref;
      this.showRef = true;
    }
  }

  setShowRefState() {
    this.showRef = !this.showRef;

    if (this.showRef) {
      const ref = localStorage.getItem('ref') ?? '';

      if (ref) {
        this.currentRefferal = ref;
      } else {
        timer(200)
        .pipe(takeUntil(this.destroyed$))
        .subscribe(() => this.promoCodeInput.nativeElement.focus())
      }
    } else {
      this.currentRefferal = '';
    }
  }

  // setRefState() {    
  //   const refState = Number(localStorage.getItem(this.keyRef)) === 0 ? 1 : 0;
  //   localStorage.setItem(this.keyRef, String(refState));
  // }

  submitCode() {
    if (this.currentRefferal) {
      localStorage.setItem('ref', this.currentRefferal);
    }
    this.walletService.connectWallet()
    this.onSuccess();
    this.bsModalRef.hide();
  }

  ngOnDestroy(): void {    
    this.destroyed$.next();
    this.destroyed$.complete();
  }
}
